import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {RoutePrefix} from '../shared/route-prefix';
import {FilterParam} from '@ngx-ivengi/crud/request-params';

@Component({
  selector: 'app-customer-contact-form',
  templateUrl: './customer-contact-form.component.html'
})
export class CustomerContactFormComponent implements OnInit {

  public routePrefix: RoutePrefix;
  public contactFilter: FilterParam;

  constructor(
    private router: UIRouter
  ) {}

  public ngOnInit(): void {
    this.routePrefix = {
      entity: 'customer',
      entityId: this.router.stateService.params.id
    };

    this.contactFilter = {
      id: 0,
      key: 'roles',
      operator: 'eq',
      value: 'CUSTOMER',
      filterFn: 'substringof',
      filterOutcome: 'true'
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer-contact-form.component.ts